import React, { useState } from "react";
import { EditOutlined, NotificationTwoTone } from "@ant-design/icons";
import { Common } from "@secondcloset/types";
import { OrganizationDetailsCard } from "@secondcloset/web-components";
import { Button, Popover, Typography, Spin } from "antd";
import { useHistory } from "react-router";
import colors from "../../../../../css/colors";
import { useMutation } from "react-query";
import { createOrganizationApiPartner } from "api/accounts/organization";
import ApiPartnerKeys from "./Modal/ApiPartnerKeys";
import { useOrganizationConfigs } from "../../../../../hooks/api/fulfillment/organization";

interface InfoCardProps {
  organization?: Common.Organization;
  loading: boolean;
}

const InfoCard: React.FC<InfoCardProps> = (props) => {
  const { name = "", id: organizationID = "" } = props.organization || {};
  const history = useHistory();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [clientId, setClientId] = useState<string>("");
  const [clientSecret, setClientSecret] = useState<string>("");

  const { data: configs } = useOrganizationConfigs(organizationID);

  const { mutateAsync: doCreateOrganizationApiPartner } = useMutation(
    (parameters: { organization_id: string }) => createOrganizationApiPartner(parameters.organization_id),
    {}
  );

  const createViewApiPartner = async () => {
    const response = await doCreateOrganizationApiPartner({ organization_id: organizationID || "" });

    if (response?.client_id && response?.client_secret) {
      setIsVisible(true);
      setClientId(response.client_id);
      setClientSecret(response.client_secret);
    }
  };

  const renderOrgNameWithEditBtn = () => {
    return (
      <div className="org-index-title-with-edit">
        <div className="org-name">
          <Typography.Text>{name}</Typography.Text>
          {!props.loading && configs?.inventory_source === "internal" && (
            <Popover content="This organization has warehouse (Providence) enabled as the stock source of truth">
              <NotificationTwoTone twoToneColor={colors.GREEN} />
            </Popover>
          )}
        </div>
        <div className="org-action-buttons">
          <Button icon={<EditOutlined />} onClick={createViewApiPartner}>
            Create/View API partner
          </Button>
          <Button icon={<EditOutlined />} onClick={() => history.push(`/organizations/${organizationID}/edit`)}>
            Edit
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className="organization-info-card">
      <ApiPartnerKeys
        visible={isVisible}
        updateModalState={() => setIsVisible(false)}
        clientId={clientId}
        clientSecret={clientSecret}
      />
      <Spin spinning={props.loading}>
        {renderOrgNameWithEditBtn()}
        <OrganizationDetailsCard organization={props.organization} />
      </Spin>
    </div>
  );
};

export default InfoCard;
